import { useCallback, useState } from 'react'

export type SelectedPrice = {
  col: string
  matrix: string
  cost: number
  supplierName: string | null
}

export function useKpMode() {
  const [kpMode, setKpMode] = useState(false)
  const [selectedPrices, setSelectedPrices] = useState<Map<string, SelectedPrice>>(new Map())
  const [kpMarkups, setKpMarkups] = useState<Record<string, number>>({
    stock: 1.8,
    other: 1.6,
    rf: 1.5,
    china: 1.8,
    manuf: 1.6,
  })
  const [positionOverrides, setPositionOverrides] = useState<Record<string, number>>({})
  const [showOverrides, setShowOverrides] = useState(false)

  const handleSelectPrice = useCallback(
    (itemId: string, col: string, matrix: string, cost: number, supplierName: string | null) => {
      setSelectedPrices((prev) => {
        const next = new Map(prev)
        if (next.get(itemId)?.col === col) {
          next.delete(itemId)
        } else {
          next.set(itemId, { col, matrix, cost, supplierName })
        }
        return next
      })
    },
    [],
  )

  /**
   * Вход в режим КП. Разрешён только когда загружены курс CNY и коэффициенты
   * наценки (`pricingReady`): без них себестоимость считается по фолбэкам и КП
   * уходит клиенту заниженным. Возвращает признак успеха — вызывающий код
   * показывает плашку/тост, если вход не состоялся.
   */
  const enterKpMode = useCallback((pricingReady: boolean): boolean => {
    if (!pricingReady) return false
    setKpMode(true)
    return true
  }, [])

  const handleCancelKp = () => {
    setKpMode(false)
    setSelectedPrices(new Map())
    setPositionOverrides({})
    setShowOverrides(false)
  }

  return {
    kpMode,
    setKpMode,
    enterKpMode,
    selectedPrices,
    setSelectedPrices,
    kpMarkups,
    setKpMarkups,
    positionOverrides,
    setPositionOverrides,
    showOverrides,
    setShowOverrides,
    handleSelectPrice,
    handleCancelKp,
  }
}
